import React, { useRef, useState, useLayoutEffect } from "react";
import "./OverflowedText.css";

const OverflowedText = ({ className = "", overflowedText = "", children }) => {
  const overflowedElement = useRef(null);
  const [showTooltip, setShowTooltip] = useState(false);
  useLayoutEffect(() => {
    if (
      overflowedElement.current.scrollWidth >
      overflowedElement.current.offsetWidth
    ) {
      setShowTooltip(true);
    }
  }, []);

  return (
    <div className={`${className} overflowedText`} ref={overflowedElement}>
      <span className="overflowedText__text">{children}</span>
      <span
        className={`overflowedText__arrow ${!showTooltip && "d-none"}`}
      ></span>
      <span className={`overflowedText__tooltip ${!showTooltip && "d-none"}`}>
        {overflowedText}
      </span>
    </div>
  );
};
export default OverflowedText;
